import './shannondell/style';
import FormStructure from './shannondell/form_structure';

export default FormStructure;